<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row dense>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium">
            {{ $t('transfer_instruction_type') }}
          </h1>
        </v-col>
        <v-col class="pt-0">
          <ValidationProvider
            :name="$t('transfer_index_type')"
            rules="required"
            v-slot="{ errors }"
          >
            <v-radio-group
              v-model="permanentInstruction.trType"
              :error-messages="errors[0]"
              @change="changeType"
            >
              <v-radio class="mt-0" value="local">
                <template #label>
                  <span class="label primary--text">{{ $t('transfer_local_panama') }}</span>
                </template>
              </v-radio>
              <v-radio class="mt-2" value="international">
                <template #label>
                  <span class="label primary--text">{{ $t('transfer_international_account') }}</span>
                </template>
              </v-radio>
              <v-radio class="mt-2" value="avsInternal">
                <template #label>
                  <span class="label primary--text">{{ $t('transfer_internal_account') }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
export default {
  components: {
    WizardForm
  },
  props: {
    permanentInstruction: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      instructionType: ''
    }
  },
  methods: {
    changeType() {
      this.$emit('changeInstructionType')
    }
  }
}
</script>
<style lang="sass" scoped>
.label
  font-size: 1.286rem

</style>
